export function getUrlParams(url) {
  var params = {}
  try {
    var parser = document.createElement('a')
    parser.href = url
    var query = parser.search.substring(1)
    if (!query) return params
    var vars = query.split('&')
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split('=')
      pair[0] = pair[0].replace('amp;', '')
      params[pair[0]] = decodeURIComponent(pair[1])
    }
  } catch (e) {
    console.log('Error in parsing URL params -> ', e)
  }
  return params
}

export function getExclusiveDomainParts(customDomain) {
  try {
    const parser = document.createElement('a')
    parser.href = customDomain
    const host = parser.host
    const domainParts = host.split('.')

    let offer, brandName;

    // First, try the new style (foo.bar.com -> foo, bar)
    if (domainParts.length >= 3) {
      [offer, brandName] = domainParts;
    } else {
      // Fallback to the old style (foo-bar.com -> foo, bar)
      const nakedDomain = domainParts[domainParts.length - 2];
      [offer, brandName] = nakedDomain.split('-');
    }

    return { offer, brandName }
  } catch (error) {
    console.log('Error in getExclusiveDomainParts() -> ', error)
    return { offer: null, brandName: null }
  }
}

export function getAltDomain() {
  try {
    let params = new URL(window.location.toString()).searchParams;
    return params.get('altdomain');
  } catch (e) {
    console.error('Unable to parse altdomain query param from window.location', e)
  }
}